import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { Session } from '../../../../services/Session';
import { LoadingService } from '../../../../services/LoadingService';
import { PageTitleService } from '../../../../services/PageTitle';
import { StateService } from '../../../../services/StateService';
import { ToastService } from '../../../../services/Toast.service';
import { SwitchBoard } from '../../../../services/SwitchBoard';
import { NumeralService } from '../../../../services/Numeral.service';
import { LogoService } from '../../../../services/LogoService';

import { environment } from '../../../../../environments/environment';
import { TOAST_TYPE } from '../../../../constants/Tpiq.constants';

import { TaxPlanningService } from '../../../../tpiq-services/tax-planning.service';
import { ManageTaxStrategiesServices } from '../../../../tpiq-services/manage-tax-strategies.service';

import { ModelBasedNumeral } from '../../../../directives/model-numeral';
import { FormatAmountPipe } from '../../../../pipes/format-amount.pipe';
  
declare const _: any;
declare const jQuery: any;
declare const moment: any;

@Component({
  selector: 'app-estimate-details',
  standalone: true,
  imports: [CommonModule, FormsModule, ModelBasedNumeral, FormatAmountPipe],
  templateUrl: './estimate-detailed-calculation.component.html'
})
  export class EstimateDetailedCalculationComponent implements OnInit, OnDestroy, OnChanges {
    org: string = Session.getOrg();
    user: any = {};
    orgName: string;
    orgLogo: string;
    destroy$: EventEmitter<void> = new EventEmitter<void>();
    currentEnvironment: any;
    @Input() currentPlanYear: any;
    @Input() filingStatus: any;
    @Input() detailReport: any;
    @Input() taxPlanData: any;
    @Input() currentProjection: any;
    @Input() projectionsData: any;
    @Input() w2Change: any;
    @Input() estimatesChange: any;
    @Input() clientsList: any;
    @Input() strategies: any;
    @Input() associatedWithData: any;
    @Input() stateAssociatedWithData: any;
    @Input() allAssociatedData: any;
    @Input() clientData: any;
    @Output() triggerRefreshStrategies: EventEmitter<any> = new EventEmitter<any>();
  
    incomeInfo: any = {
      wagesTaxpayer: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      wagesSpouse: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      interest: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      dividents: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      businessIncome: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      stCapGn: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      ltCapGn: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      otherGainsOrLosses: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      rentsAndLoyalties: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      k1Passthrough: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      otherIncome: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      totalIncome: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
    };
    adjustmentsToIncomeInfo: any = {
      hsa: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      retirementBySpouse: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      selfEmployedTax: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      selfEmployedHealthInsDed: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      otherAdjustments: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      estimatedAdjustedGrossInc: {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
    };
    otherDetailedInfo: any = {
      schAMedical : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      schATaxes : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      schAInterest : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      schACharitable : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      schAOtherOrLimitation : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      totalItemizedDeductions : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      standardDeduction : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      taxableIncBeforeQBI : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      qualifiedBusinessIncDed : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      finalTaxableIncome : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      taxOrdinary : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      amt : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      otherTaxes : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      seTax : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      creditsToOffsetTaxDue : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      totalTax : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      withholdingTaxpayer : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      withholdingSpouse : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      estimatedTaxPayments : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      netTaxDue : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      underPaymentPenalties : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      totalDue : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      effectiveTaxRate : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
      marginalTaxRate : {lastYearValue: '', currentYearvalue: '', difference: '', notes: ''},
    };
    reveal: any = {
      displayFormulaInfo: false,
      showStrategies: false,
      addSuggestionToEstimate: false,
      addStrategyFromEstimate: false
    };
    currentInfoKey: any;
    strategiesList: any;
    suggestionsList: any;
    suggestionsData: any;
    strategyDropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    suggestionDropdownSettings = {
      singleSelection: false,
      idField: 'strategyId',
      textField: 'strategyName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    selectedStrategies = [];
    selectedSuggestions = [];
    currentNotes: any;
    currentObject: any;
    currentKey: any;
    selectedViewStrategy: any;
    isMinimized = false;
    currentSelectedSuggestion: any;
    isSuggestionExist: boolean = false;
    constructor(
      private _router: Router,
      private _route: ActivatedRoute,
      private titleService: PageTitleService,
      private loadingService: LoadingService,
      private stateService: StateService,
      private toastService: ToastService,
      private switchBoard: SwitchBoard,
      private logoService: LogoService,
      private taxPlanningService: TaxPlanningService,
      private numeralService: NumeralService,
      private taxStrategyServices: ManageTaxStrategiesServices
    ) {}
  
    ngOnInit(): void {
      const base = this;
      this.user = Session.getUser();
      this.orgName = this.user.org || '';
      this.orgLogo = this.logoService.getLoginLogoUrl();
      this.currentEnvironment = environment;
      this.getStrategiesList();
      this.getEstimateSuggestions();
      if (!_.isEmpty(this.detailReport)) {
        const dr: any = this.detailReport || {};

        if (dr.incomeInfo && typeof dr.incomeInfo === 'object') {
          this.incomeInfo = {
            ...this.incomeInfo,
            ...dr.incomeInfo
          };
        }

        if (dr.adjustmentsToIncomeInfo && typeof dr.adjustmentsToIncomeInfo === 'object') {
          this.adjustmentsToIncomeInfo = {
            ...this.adjustmentsToIncomeInfo,
            ...dr.adjustmentsToIncomeInfo
          };
        }

        if (dr.otherDetailedInfo && typeof dr.otherDetailedInfo === 'object') {
          this.otherDetailedInfo = {
            ...this.otherDetailedInfo,
            ...dr.otherDetailedInfo
          };
        }
      }
      this.otherDetailedInfo.marginalTaxRate.currentYearvalue = this.taxPlanData.marginalRate;
      this.otherDetailedInfo.marginalTaxRate.difference = this.otherDetailedInfo.marginalTaxRate.currentYearvalue - this.otherDetailedInfo.marginalTaxRate.lastYearValue;
      this.calculateMarginalRateForCurrentYear();
      this.calculateMarginalRateForPreviousYear();
      this.recalculateDifferencesAndTotals();
    }

    ngOnChanges(changes: SimpleChanges): void {
      // detailReport usually arrives async after ngOnInit, so apply it even on firstChange
      if (changes && changes['detailReport']) {
        const dr: any = changes['detailReport'].currentValue || {};
    
        if (dr && typeof dr === 'object') {
          if (dr.incomeInfo && typeof dr.incomeInfo === 'object') {
            this.incomeInfo = { ...this.incomeInfo, ...dr.incomeInfo };
          }
          if (dr.adjustmentsToIncomeInfo && typeof dr.adjustmentsToIncomeInfo === 'object') {
            this.adjustmentsToIncomeInfo = { ...this.adjustmentsToIncomeInfo, ...dr.adjustmentsToIncomeInfo };
          }
          if (dr.otherDetailedInfo && typeof dr.otherDetailedInfo === 'object') {
            this.otherDetailedInfo = { ...this.otherDetailedInfo, ...dr.otherDetailedInfo };
          }
        }
        this.recalculateDifferencesAndTotals();
      }
    }

    /**
     * Ensure differences + simple totals are computed when data loads (not only on blur).
     * The UI currently recalculates many rows on (blur); this forces an initial calculation.
     */
    private recalculateDifferencesAndTotals(): void {
      // Income: field-by-field differences
      const incomeKeys = [
        'wagesTaxpayer',
        'wagesSpouse',
        'interest',
        'dividents',
        'businessIncome',
        'stCapGn',
        'ltCapGn',
        'otherGainsOrLosses',
        'rentsAndLoyalties',
        'k1Passthrough',
        'otherIncome'
      ];

      for (const k of incomeKeys) {
        this.computeDiff(this.incomeInfo, k);
      }

      // Income totals
      this.computeSumTotal(this.incomeInfo, incomeKeys, 'totalIncome');

      // Adjustments: just compute diffs (don’t derive AGI; OCR already provides it)
      const adjKeys = [
        'hsa',
        'retirementBySpouse',
        'selfEmployedTax',
        'selfEmployedHealthInsDed',
        'otherAdjustments',
        'estimatedAdjustedGrossInc'
      ];
      for (const k of adjKeys) {
        this.computeDiff(this.adjustmentsToIncomeInfo, k);
      }

      // Schedule A total itemized deductions (simple sum)
      const schAKeys = [
        'schAMedical',
        'schATaxes',
        'schAInterest',
        'schACharitable',
        'schAOtherOrLimitation'
      ];
      this.computeSumTotal(this.otherDetailedInfo, schAKeys, 'totalItemizedDeductions');

      // Other detailed diffs (including totals if present)
      const otherKeys = [
        'schAMedical',
        'schATaxes',
        'schAInterest',
        'schACharitable',
        'schAOtherOrLimitation',
        'totalItemizedDeductions',
        'standardDeduction',
        'taxableIncBeforeQBI',
        'qualifiedBusinessIncDed',
        'finalTaxableIncome',
        'taxOrdinary',
        'amt',
        'otherTaxes',
        'seTax',
        'creditsToOffsetTaxDue',
        'totalTax',
        'withholdingTaxpayer',
        'withholdingSpouse',
        'estimatedTaxPayments',
        'netTaxDue',
        'underPaymentPenalties',
        'totalDue',
        'effectiveTaxRate',
        'marginalTaxRate'
      ];
      for (const k of otherKeys) {
        this.computeDiff(this.otherDetailedInfo, k);
      }

      // If taxable-before-QBI is blank but we have final + QBI, derive it (both years)
      this.deriveTaxableBeforeQBI();

      // Marginal rates depend on taxable income + filing status
      // Re-run after we normalize diffs/totals
      this.calculateMarginalRateForCurrentYear();
      this.calculateMarginalRateForPreviousYear();
    }

    private computeDiff(section: any, key: string): void {
      if (!section || !section[key]) return;
      const last = this.toNumber(section[key].lastYearValue);
      const curr = this.toNumber(section[key].currentYearvalue);
      section[key].difference = curr - last;
    }

    private computeSumTotal(section: any, keys: string[], totalKey: string): void {
      if (!section || !section[totalKey]) return;
      let last = 0;
      let curr = 0;
      for (const k of keys) {
        if (!section[k]) continue;
        last += this.toNumber(section[k].lastYearValue);
        curr += this.toNumber(section[k].currentYearvalue);
      }
      section[totalKey].lastYearValue = last;
      section[totalKey].currentYearvalue = curr;
      section[totalKey].difference = curr - last;
    }

    /**
     * taxableIncBeforeQBI is often intended to be: finalTaxableIncome + qualifiedBusinessIncDed.
     * Only fill it if currently blank/zero to avoid overwriting user edits.
     */
    private deriveTaxableBeforeQBI(): void {
      if (!this.otherDetailedInfo) return;
      const before = this.otherDetailedInfo.taxableIncBeforeQBI;
      const final = this.otherDetailedInfo.finalTaxableIncome;
      const qbi = this.otherDetailedInfo.qualifiedBusinessIncDed;
      if (!before || !final || !qbi) return;

      const beforeLast = this.toNumber(before.lastYearValue);
      const beforeCurr = this.toNumber(before.currentYearvalue);

      // treat empty-string as "unset" (model-numeral commonly uses '')
      const beforeLastUnset = (before.lastYearValue === '' || before.lastYearValue === null || before.lastYearValue === undefined);
      const beforeCurrUnset = (before.currentYearvalue === '' || before.currentYearvalue === null || before.currentYearvalue === undefined);

      if (beforeLastUnset || beforeLast === 0) {
        before.lastYearValue = this.toNumber(final.lastYearValue) + this.toNumber(qbi.lastYearValue);
      }
      if (beforeCurrUnset || beforeCurr === 0) {
        before.currentYearvalue = this.toNumber(final.currentYearvalue) + this.toNumber(qbi.currentYearvalue);
      }
      before.difference = this.toNumber(before.currentYearvalue) - this.toNumber(before.lastYearValue);
    }

    private toNumber(v: any): number {
      if (v === null || v === undefined) return 0;
      if (typeof v === 'number') return isFinite(v) ? v : 0;
      if (typeof v === 'string') {
        const s = v.trim();
        if (!s) return 0;
        // Remove currency symbols, commas, spaces. Keep leading minus.
        const cleaned = s.replace(/[$,\s]/g, '');
        const n = Number(cleaned);
        return isFinite(n) ? n : 0;
      }
      return 0;
    }
  
    calculateMarginalRateForCurrentYear() {
      if (this.filingStatus == 'Single') {
        if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 0) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 9950)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 10;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 9951) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 40525)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 12;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 40526) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 86375)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 22;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 86376) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 164925)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 24;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 164926) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 209425)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 32;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 209426) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 523600)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 35;
        } else if (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 523601) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 37;
        }
      } else if (this.filingStatus == 'MFS') {
        if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 0) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 9950)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 10;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 9951) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 40525)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 12;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 40526) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 86375)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 22;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 86376) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 164925)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 24;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 164926) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 209425)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 32;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 209426) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 314150)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 35;
        } else if (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 314151) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 37;
        }
      } else if (this.filingStatus == 'MFJ') {
        if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 0) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 19900)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 10;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 19901) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 81050)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 12;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 81051) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 172750)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 22;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 172751) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 329850)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 24;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 329851) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 418850)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 32;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 418851) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 628300)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 35;
        } else if (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 628301) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 37;
        }
      } else if (this.filingStatus == 'Head of Household') {
        if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 0) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 14200)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 10;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 14201) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 54200)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 12;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 54201) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 86350)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 22;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 86351) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 164900)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 24;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 164901) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 209400)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 32;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 209401) && (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue <= 523600)) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 35;
        } else if (this.otherDetailedInfo.finalTaxableIncome.currentYearvalue >= 523601) {
          this.otherDetailedInfo.marginalTaxRate.currentYearvalue = 37;
        }
      }
  
      this.otherDetailedInfo.marginalTaxRate.difference = this.otherDetailedInfo.marginalTaxRate.currentYearvalue - this.otherDetailedInfo.marginalTaxRate.lastYearValue;
    }
  
    calculateMarginalRateForPreviousYear() {
      if (this.filingStatus == 'Single') {
        if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 0) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 9950)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 10;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 9951) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 40525)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 12;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 40526) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 86375)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 22;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 86376) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 164925)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 24;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 164926) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 209425)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 32;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 209426) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 523600)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 35;
        } else if (this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 523601) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 37;
        }
      } else if (this.filingStatus == 'MFS') {
        if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 0) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 9950)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 10;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 9951) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 40525)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 12;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 40526) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 86375)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 22;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 86376) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 164925)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 24;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 164926) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 209425)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 32;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 209426) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 314150)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 35;
        } else if (this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 314151) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 37;
        }
      } else if (this.filingStatus == 'MFJ') {
        if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 0) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 19900)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 10;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 19901) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 81050)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 12;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 81051) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 172750)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 22;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 172751) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 329850)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 24;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 329851) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 418850)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 32;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 418851) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 628300)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 35;
        } else if (this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 628301) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 37;
        }
      } else if (this.filingStatus == 'Head of Household') {
        if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 0) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 14200)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 10;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 14201) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 54200)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 12;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 54201) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 86350)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 22;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 86351) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 164900)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 24;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 164901) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 209400)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 32;
        } else if ((this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 209401) && (this.otherDetailedInfo.finalTaxableIncome.lastYearValue <= 523600)) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 35;
        } else if (this.otherDetailedInfo.finalTaxableIncome.lastYearValue >= 523601) {
          this.otherDetailedInfo.marginalTaxRate.lastYearValue = 37;
        }
      }
  
      this.otherDetailedInfo.marginalTaxRate.difference = this.otherDetailedInfo.marginalTaxRate.currentYearvalue - this.otherDetailedInfo.marginalTaxRate.lastYearValue;
    }
  
    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.unsubscribe();
      this.switchBoard.onToggleFeedback.next({
        display: false
      });
    }
  
    calculateFinalTaxableIncome() {
      this.otherDetailedInfo.finalTaxableIncome.lastYearValue = this.otherDetailedInfo.taxableIncBeforeQBI.lastYearValue - this.otherDetailedInfo.qualifiedBusinessIncDed.lastYearValue;
      this.otherDetailedInfo.finalTaxableIncome.currentYearvalue = this.otherDetailedInfo.taxableIncBeforeQBI.currentYearvalue - this.otherDetailedInfo.qualifiedBusinessIncDed.currentYearvalue;
      this.otherDetailedInfo.finalTaxableIncome.difference = this.otherDetailedInfo.finalTaxableIncome.currentYearvalue - this.otherDetailedInfo.finalTaxableIncome.lastYearValue;
      this.calculateEffectiveTaxRate();
      this.calculateMarginalRateForPreviousYear();
    }
  
    calculateTaxableIncomeBeforeQBI() {
      if (this.otherDetailedInfo.totalItemizedDeductions.lastYearValue >= this.otherDetailedInfo.standardDeduction.lastYearValue) {
        this.otherDetailedInfo.taxableIncBeforeQBI.lastYearValue = this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue - this.otherDetailedInfo.totalItemizedDeductions.lastYearValue;
      } else if (this.otherDetailedInfo.totalItemizedDeductions.lastYearValue < this.otherDetailedInfo.standardDeduction.lastYearValue) {
        this.otherDetailedInfo.taxableIncBeforeQBI.lastYearValue = this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue - this.otherDetailedInfo.standardDeduction.lastYearValue;
      }
  
      if (this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue >= this.otherDetailedInfo.standardDeduction.currentYearvalue) {
        this.otherDetailedInfo.taxableIncBeforeQBI.currentYearvalue = this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue - this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue;
      } else if (this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue < this.otherDetailedInfo.standardDeduction.currentYearvalue) {
        this.otherDetailedInfo.taxableIncBeforeQBI.currentYearvalue = this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue - this.otherDetailedInfo.standardDeduction.currentYearvalue;
      }
      this.otherDetailedInfo.taxableIncBeforeQBI.difference = this.otherDetailedInfo.finalTaxableIncome.currentYearvalue - this.otherDetailedInfo.finalTaxableIncome.lastYearValue;
      this.calculateFinalTaxableIncome();
    }
  
    formatAmount(amount){
      return this.numeralService.format('$0,0', amount);
    }
  
    calculateIncomeDifferenceAmount(key, type) {
      this.incomeInfo[key].difference = this.incomeInfo[key].currentYearvalue - this.incomeInfo[key].lastYearValue;
      this.calculateIncomeTotal(type);
    }
  
    calculateIncomeTotal(type) {
      if (type == 'previous') {
        this.incomeInfo.totalIncome.lastYearValue = 0;
        this.incomeInfo.totalIncome.lastYearValue = (this.incomeInfo.wagesTaxpayer.lastYearValue) ? this.incomeInfo.totalIncome.lastYearValue + this.incomeInfo.wagesTaxpayer.lastYearValue : this.incomeInfo.totalIncome.lastYearValue;
        this.incomeInfo.totalIncome.lastYearValue = (this.incomeInfo.wagesSpouse.lastYearValue) ? this.incomeInfo.totalIncome.lastYearValue + this.incomeInfo.wagesSpouse.lastYearValue : this.incomeInfo.totalIncome.lastYearValue;
        this.incomeInfo.totalIncome.lastYearValue = (this.incomeInfo.interest.lastYearValue) ? this.incomeInfo.totalIncome.lastYearValue + this.incomeInfo.interest.lastYearValue : this.incomeInfo.totalIncome.lastYearValue;
        this.incomeInfo.totalIncome.lastYearValue = (this.incomeInfo.dividents.lastYearValue) ? this.incomeInfo.totalIncome.lastYearValue + this.incomeInfo.dividents.lastYearValue : this.incomeInfo.totalIncome.lastYearValue;
        this.incomeInfo.totalIncome.lastYearValue = (this.incomeInfo.businessIncome.lastYearValue) ? this.incomeInfo.totalIncome.lastYearValue + this.incomeInfo.businessIncome.lastYearValue : this.incomeInfo.totalIncome.lastYearValue;
        this.incomeInfo.totalIncome.lastYearValue = (this.incomeInfo.stCapGn.lastYearValue) ? this.incomeInfo.totalIncome.lastYearValue + this.incomeInfo.stCapGn.lastYearValue : this.incomeInfo.totalIncome.lastYearValue;
        this.incomeInfo.totalIncome.lastYearValue = (this.incomeInfo.ltCapGn.lastYearValue) ? this.incomeInfo.totalIncome.lastYearValue + this.incomeInfo.ltCapGn.lastYearValue : this.incomeInfo.totalIncome.lastYearValue;
        this.incomeInfo.totalIncome.lastYearValue = (this.incomeInfo.otherGainsOrLosses.lastYearValue) ? this.incomeInfo.totalIncome.lastYearValue + this.incomeInfo.otherGainsOrLosses.lastYearValue : this.incomeInfo.totalIncome.lastYearValue;
        this.incomeInfo.totalIncome.lastYearValue = (this.incomeInfo.rentsAndLoyalties.lastYearValue) ? this.incomeInfo.totalIncome.lastYearValue + this.incomeInfo.rentsAndLoyalties.lastYearValue : this.incomeInfo.totalIncome.lastYearValue;
        this.incomeInfo.totalIncome.lastYearValue = (this.incomeInfo.k1Passthrough.lastYearValue) ? this.incomeInfo.totalIncome.lastYearValue + this.incomeInfo.k1Passthrough.lastYearValue : this.incomeInfo.totalIncome.lastYearValue;
        this.incomeInfo.totalIncome.lastYearValue = (this.incomeInfo.otherIncome.lastYearValue) ? this.incomeInfo.totalIncome.lastYearValue + this.incomeInfo.otherIncome.lastYearValue : this.incomeInfo.totalIncome.lastYearValue;
      } else if (type == 'current') {
        this.incomeInfo.totalIncome.currentYearvalue = 0;
        this.incomeInfo.totalIncome.currentYearvalue = (this.incomeInfo.wagesTaxpayer.currentYearvalue) ? this.incomeInfo.totalIncome.currentYearvalue + this.incomeInfo.wagesTaxpayer.currentYearvalue : this.incomeInfo.totalIncome.currentYearvalue;
        this.incomeInfo.totalIncome.currentYearvalue = (this.incomeInfo.wagesSpouse.currentYearvalue) ? this.incomeInfo.totalIncome.currentYearvalue + this.incomeInfo.wagesSpouse.currentYearvalue : this.incomeInfo.totalIncome.currentYearvalue;
        this.incomeInfo.totalIncome.currentYearvalue = (this.incomeInfo.interest.currentYearvalue) ? this.incomeInfo.totalIncome.currentYearvalue + this.incomeInfo.interest.currentYearvalue : this.incomeInfo.totalIncome.currentYearvalue;
        this.incomeInfo.totalIncome.currentYearvalue = (this.incomeInfo.dividents.currentYearvalue) ? this.incomeInfo.totalIncome.currentYearvalue + this.incomeInfo.dividents.currentYearvalue : this.incomeInfo.totalIncome.currentYearvalue;
        this.incomeInfo.totalIncome.currentYearvalue = (this.incomeInfo.businessIncome.currentYearvalue) ? this.incomeInfo.totalIncome.currentYearvalue + this.incomeInfo.businessIncome.currentYearvalue : this.incomeInfo.totalIncome.currentYearvalue;
        this.incomeInfo.totalIncome.currentYearvalue = (this.incomeInfo.stCapGn.currentYearvalue) ? this.incomeInfo.totalIncome.currentYearvalue + this.incomeInfo.stCapGn.currentYearvalue : this.incomeInfo.totalIncome.currentYearvalue;
        this.incomeInfo.totalIncome.currentYearvalue = (this.incomeInfo.ltCapGn.currentYearvalue) ? this.incomeInfo.totalIncome.currentYearvalue + this.incomeInfo.ltCapGn.currentYearvalue : this.incomeInfo.totalIncome.currentYearvalue;
        this.incomeInfo.totalIncome.currentYearvalue = (this.incomeInfo.otherGainsOrLosses.currentYearvalue) ? this.incomeInfo.totalIncome.currentYearvalue + this.incomeInfo.otherGainsOrLosses.currentYearvalue : this.incomeInfo.totalIncome.currentYearvalue;
        this.incomeInfo.totalIncome.currentYearvalue = (this.incomeInfo.rentsAndLoyalties.currentYearvalue) ? this.incomeInfo.totalIncome.currentYearvalue + this.incomeInfo.rentsAndLoyalties.currentYearvalue : this.incomeInfo.totalIncome.currentYearvalue;
        this.incomeInfo.totalIncome.currentYearvalue = (this.incomeInfo.k1Passthrough.currentYearvalue) ? this.incomeInfo.totalIncome.currentYearvalue + this.incomeInfo.k1Passthrough.currentYearvalue : this.incomeInfo.totalIncome.currentYearvalue;
        this.incomeInfo.totalIncome.currentYearvalue = (this.incomeInfo.otherIncome.currentYearvalue) ? this.incomeInfo.totalIncome.currentYearvalue + this.incomeInfo.otherIncome.currentYearvalue : this.incomeInfo.totalIncome.currentYearvalue;
      }
      this.incomeInfo.totalIncome.difference = this.incomeInfo.totalIncome.currentYearvalue - this.incomeInfo.totalIncome.lastYearValue;
      this.calculateAdjustableIncomeTotal(type);
    }
  
    calculateAdjIncomeDifferenceAmount(key, type) {
      this.adjustmentsToIncomeInfo[key].difference = this.adjustmentsToIncomeInfo[key].currentYearvalue - this.adjustmentsToIncomeInfo[key].lastYearValue;
      this.calculateAdjustableIncomeTotal(type);
      if (key == 'selfEmployedTax') {
        this.otherDetailedInfo.seTax.lastYearValue = (this.adjustmentsToIncomeInfo[key].lastYearValue) ? this.adjustmentsToIncomeInfo[key].lastYearValue * 2 : 0;
        this.otherDetailedInfo.seTax.currentYearvalue = (this.adjustmentsToIncomeInfo[key].currentYearvalue) ? this.adjustmentsToIncomeInfo[key].currentYearvalue * 2 : 0;
        this.otherDetailedInfo.seTax.difference = this.otherDetailedInfo.seTax.currentYearvalue - this.otherDetailedInfo.seTax.lastYearValue;
        this.calculateTaxTotal();
      }
    }
  
    calculateAdjustableIncomeTotal(type) {
      if (type == 'previous') {
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue = 0;
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue = (this.adjustmentsToIncomeInfo.hsa.lastYearValue) ? this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue + this.adjustmentsToIncomeInfo.hsa.lastYearValue : this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue;
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue = (this.adjustmentsToIncomeInfo.retirementBySpouse.lastYearValue) ? this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue + this.adjustmentsToIncomeInfo.retirementBySpouse.lastYearValue : this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue;
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue = (this.adjustmentsToIncomeInfo.selfEmployedTax.lastYearValue) ? this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue + this.adjustmentsToIncomeInfo.selfEmployedTax.lastYearValue : this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue;
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue = (this.adjustmentsToIncomeInfo.selfEmployedHealthInsDed.lastYearValue) ? this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue + this.adjustmentsToIncomeInfo.selfEmployedHealthInsDed.lastYearValue : this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue;
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue = (this.adjustmentsToIncomeInfo.otherAdjustments.lastYearValue) ? this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue + this.adjustmentsToIncomeInfo.otherAdjustments.lastYearValue : this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue;
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue = this.incomeInfo.totalIncome.lastYearValue - this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue;
      } else if (type == 'current') {
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue = 0;
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue = (this.adjustmentsToIncomeInfo.hsa.currentYearvalue) ? this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue + this.adjustmentsToIncomeInfo.hsa.currentYearvalue : this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue;
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue = (this.adjustmentsToIncomeInfo.retirementBySpouse.currentYearvalue) ? this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue + this.adjustmentsToIncomeInfo.retirementBySpouse.currentYearvalue : this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue;
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue = (this.adjustmentsToIncomeInfo.selfEmployedTax.currentYearvalue) ? this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue + this.adjustmentsToIncomeInfo.selfEmployedTax.currentYearvalue : this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue;
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue = (this.adjustmentsToIncomeInfo.selfEmployedHealthInsDed.currentYearvalue) ? this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue + this.adjustmentsToIncomeInfo.selfEmployedHealthInsDed.currentYearvalue : this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue;
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue = (this.adjustmentsToIncomeInfo.otherAdjustments.currentYearvalue) ? this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue + this.adjustmentsToIncomeInfo.otherAdjustments.currentYearvalue : this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue;
        this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue = this.incomeInfo.totalIncome.currentYearvalue - this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue;
      }
      this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.difference = this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.currentYearvalue - this.adjustmentsToIncomeInfo.estimatedAdjustedGrossInc.lastYearValue;
      this.calculateItemizedDeductionsTotal(type);
    }
  
    calculateItemizedDeductionsDiffAmount(key, type) {
      this.otherDetailedInfo[key].difference = this.otherDetailedInfo[key].currentYearvalue - this.otherDetailedInfo[key].lastYearValue;
      this.calculateItemizedDeductionsTotal(type);
    }
  
    calculateItemizedDeductionsTotal(type) {
      if (type == 'previous') {
        this.otherDetailedInfo.totalItemizedDeductions.lastYearValue = 0;
        this.otherDetailedInfo.totalItemizedDeductions.lastYearValue = (this.otherDetailedInfo.schAMedical.lastYearValue) ? this.otherDetailedInfo.totalItemizedDeductions.lastYearValue + this.otherDetailedInfo.schAMedical.lastYearValue : this.otherDetailedInfo.totalItemizedDeductions.lastYearValue;
        this.otherDetailedInfo.totalItemizedDeductions.lastYearValue = (this.otherDetailedInfo.schATaxes.lastYearValue) ? this.otherDetailedInfo.totalItemizedDeductions.lastYearValue + this.otherDetailedInfo.schATaxes.lastYearValue : this.otherDetailedInfo.totalItemizedDeductions.lastYearValue;
        this.otherDetailedInfo.totalItemizedDeductions.lastYearValue = (this.otherDetailedInfo.schAInterest.lastYearValue) ? this.otherDetailedInfo.totalItemizedDeductions.lastYearValue + this.otherDetailedInfo.schAInterest.lastYearValue : this.otherDetailedInfo.totalItemizedDeductions.lastYearValue;
        this.otherDetailedInfo.totalItemizedDeductions.lastYearValue = (this.otherDetailedInfo.schACharitable.lastYearValue) ? this.otherDetailedInfo.totalItemizedDeductions.lastYearValue + this.otherDetailedInfo.schACharitable.lastYearValue : this.otherDetailedInfo.totalItemizedDeductions.lastYearValue;
        this.otherDetailedInfo.totalItemizedDeductions.lastYearValue = (this.otherDetailedInfo.schAOtherOrLimitation.lastYearValue) ? this.otherDetailedInfo.totalItemizedDeductions.lastYearValue + this.otherDetailedInfo.schAOtherOrLimitation.lastYearValue : this.otherDetailedInfo.totalItemizedDeductions.lastYearValue;
      } else if (type == 'current') {
        this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue = 0;
        this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue = (this.otherDetailedInfo.schAMedical.currentYearvalue) ? this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue + this.otherDetailedInfo.schAMedical.currentYearvalue : this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue;
        this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue = (this.otherDetailedInfo.schATaxes.currentYearvalue) ? this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue + this.otherDetailedInfo.schATaxes.currentYearvalue : this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue;
        this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue = (this.otherDetailedInfo.schAInterest.currentYearvalue) ? this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue + this.otherDetailedInfo.schAInterest.currentYearvalue : this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue;
        this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue = (this.otherDetailedInfo.schACharitable.currentYearvalue) ? this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue + this.otherDetailedInfo.schACharitable.currentYearvalue : this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue;
        this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue = (this.otherDetailedInfo.schAOtherOrLimitation.currentYearvalue) ? this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue + this.otherDetailedInfo.schAOtherOrLimitation.currentYearvalue : this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue;
      }
      this.otherDetailedInfo.totalItemizedDeductions.difference = this.otherDetailedInfo.totalItemizedDeductions.currentYearvalue - this.otherDetailedInfo.totalItemizedDeductions.lastYearValue;
      this.calculateTaxableIncomeBeforeQBI();
    }
  
    calculateDifference(key) {
      this.otherDetailedInfo[key].difference = this.otherDetailedInfo[key].currentYearvalue - this.otherDetailedInfo[key].lastYearValue;
      this.calculateTaxTotal();
      this.calculateNetTaxDue();
    }
  
    calculateTaxTotal() {
      this.otherDetailedInfo.totalTax.lastYearValue = 0;
      this.otherDetailedInfo.totalTax.currentYearvalue = 0;
  
      this.otherDetailedInfo.totalTax.lastYearValue = (this.otherDetailedInfo.taxOrdinary.lastYearValue) ? this.otherDetailedInfo.totalTax.lastYearValue + this.otherDetailedInfo.taxOrdinary.lastYearValue : this.otherDetailedInfo.totalTax.lastYearValue;
      this.otherDetailedInfo.totalTax.lastYearValue = (this.otherDetailedInfo.amt.lastYearValue) ? this.otherDetailedInfo.totalTax.lastYearValue + this.otherDetailedInfo.amt.lastYearValue : this.otherDetailedInfo.totalTax.lastYearValue;
      this.otherDetailedInfo.totalTax.lastYearValue = (this.otherDetailedInfo.otherTaxes.lastYearValue) ? this.otherDetailedInfo.totalTax.lastYearValue + this.otherDetailedInfo.otherTaxes.lastYearValue : this.otherDetailedInfo.totalTax.lastYearValue;
      this.otherDetailedInfo.totalTax.lastYearValue = (this.otherDetailedInfo.seTax.lastYearValue) ? this.otherDetailedInfo.totalTax.lastYearValue + this.otherDetailedInfo.seTax.lastYearValue : this.otherDetailedInfo.totalTax.lastYearValue;
      this.otherDetailedInfo.totalTax.lastYearValue = (this.otherDetailedInfo.creditsToOffsetTaxDue.lastYearValue) ? this.otherDetailedInfo.totalTax.lastYearValue + this.otherDetailedInfo.creditsToOffsetTaxDue.lastYearValue : this.otherDetailedInfo.totalTax.lastYearValue;
  
      this.otherDetailedInfo.totalTax.currentYearvalue = (this.otherDetailedInfo.taxOrdinary.currentYearvalue) ? this.otherDetailedInfo.totalTax.currentYearvalue + this.otherDetailedInfo.taxOrdinary.currentYearvalue : this.otherDetailedInfo.totalTax.currentYearvalue;
      this.otherDetailedInfo.totalTax.currentYearvalue = (this.otherDetailedInfo.amt.currentYearvalue) ? this.otherDetailedInfo.totalTax.currentYearvalue + this.otherDetailedInfo.amt.currentYearvalue : this.otherDetailedInfo.totalTax.currentYearvalue;
      this.otherDetailedInfo.totalTax.currentYearvalue = (this.otherDetailedInfo.otherTaxes.currentYearvalue) ? this.otherDetailedInfo.totalTax.currentYearvalue + this.otherDetailedInfo.otherTaxes.currentYearvalue : this.otherDetailedInfo.totalTax.currentYearvalue;
      this.otherDetailedInfo.totalTax.currentYearvalue = (this.otherDetailedInfo.seTax.currentYearvalue) ? this.otherDetailedInfo.totalTax.currentYearvalue + this.otherDetailedInfo.seTax.currentYearvalue : this.otherDetailedInfo.totalTax.currentYearvalue;
      this.otherDetailedInfo.totalTax.currentYearvalue = (this.otherDetailedInfo.creditsToOffsetTaxDue.currentYearvalue) ? this.otherDetailedInfo.totalTax.currentYearvalue + this.otherDetailedInfo.creditsToOffsetTaxDue.currentYearvalue : this.otherDetailedInfo.totalTax.currentYearvalue;
  
      this.otherDetailedInfo.totalTax.difference = this.otherDetailedInfo.totalTax.currentYearvalue - this.otherDetailedInfo.totalTax.lastYearValue;
      this.calculateNetTaxDue();
    }
  
    calculateEffectiveTaxRate() {
      this.otherDetailedInfo.effectiveTaxRate.lastYearValue = this.formatEffectiveTaxRateValue((this.otherDetailedInfo.totalTax.lastYearValue / this.otherDetailedInfo.finalTaxableIncome.lastYearValue) * 100);
      this.otherDetailedInfo.effectiveTaxRate.currentYearvalue = this.formatEffectiveTaxRateValue((this.otherDetailedInfo.totalTax.currentYearvalue / this.otherDetailedInfo.finalTaxableIncome.currentYearvalue) * 100);
      this.otherDetailedInfo.effectiveTaxRate.difference = this.formatEffectiveTaxRateValue(this.otherDetailedInfo.effectiveTaxRate.currentYearvalue - this.otherDetailedInfo.effectiveTaxRate.lastYearValue);
    }
  
    formatEffectiveTaxRateValue(amount){
      return this.numeralService.format('0,0.00', amount);
    }
  
    calculateNetTaxDue() {
      this.otherDetailedInfo.netTaxDue.lastYearValue = 0;
      this.otherDetailedInfo.netTaxDue.currentYearvalue = 0;
      let itemsLastSum = 0;
      itemsLastSum = (this.otherDetailedInfo.withholdingTaxpayer.lastYearValue) ? itemsLastSum + this.otherDetailedInfo.withholdingTaxpayer.lastYearValue : itemsLastSum;
      itemsLastSum = (this.otherDetailedInfo.withholdingSpouse.lastYearValue) ? itemsLastSum + this.otherDetailedInfo.withholdingSpouse.lastYearValue : itemsLastSum;
      itemsLastSum = (this.otherDetailedInfo.estimatedTaxPayments.lastYearValue) ? itemsLastSum + this.otherDetailedInfo.estimatedTaxPayments.lastYearValue : itemsLastSum;
      this.otherDetailedInfo.netTaxDue.lastYearValue = this.otherDetailedInfo.totalTax.lastYearValue - itemsLastSum;
  
      let itemsCurrentSum = 0;
      itemsCurrentSum = (this.otherDetailedInfo.withholdingTaxpayer.currentYearvalue) ? itemsCurrentSum + this.otherDetailedInfo.withholdingTaxpayer.currentYearvalue : itemsCurrentSum;
      itemsCurrentSum = (this.otherDetailedInfo.withholdingSpouse.currentYearvalue) ? itemsCurrentSum + this.otherDetailedInfo.withholdingSpouse.currentYearvalue : itemsCurrentSum;
      itemsCurrentSum = (this.otherDetailedInfo.estimatedTaxPayments.currentYearvalue) ? itemsCurrentSum + this.otherDetailedInfo.estimatedTaxPayments.currentYearvalue : itemsCurrentSum;
      this.otherDetailedInfo.netTaxDue.currentYearvalue = this.otherDetailedInfo.totalTax.currentYearvalue - itemsCurrentSum;
  
      this.otherDetailedInfo.netTaxDue.difference = this.otherDetailedInfo.netTaxDue.currentYearvalue - this.otherDetailedInfo.netTaxDue.lastYearValue;
      this.calculateTotalDue();
      this.calculateEffectiveTaxRate();
    }
  
    calcualtePenaltiesDiff(key) {
      this.otherDetailedInfo[key].difference = this.otherDetailedInfo[key].currentYearvalue - this.otherDetailedInfo[key].lastYearValue;
      this.calculateTotalDue();
    }
  
    calculateTotalDue() {
      this.otherDetailedInfo.totalDue.lastYearValue = 0;
      this.otherDetailedInfo.totalDue.lastYearValue = (this.otherDetailedInfo.netTaxDue.lastYearValue) ? this.otherDetailedInfo.totalDue.lastYearValue + this.otherDetailedInfo.netTaxDue.lastYearValue : this.otherDetailedInfo.totalDue.lastYearValue;
      this.otherDetailedInfo.totalDue.lastYearValue = (this.otherDetailedInfo.underPaymentPenalties.lastYearValue) ? this.otherDetailedInfo.totalDue.lastYearValue + this.otherDetailedInfo.underPaymentPenalties.lastYearValue : this.otherDetailedInfo.totalDue.lastYearValue;
  
      this.otherDetailedInfo.totalDue.currentYearvalue = 0;
      this.otherDetailedInfo.totalDue.currentYearvalue = (this.otherDetailedInfo.netTaxDue.currentYearvalue) ? this.otherDetailedInfo.totalDue.currentYearvalue + this.otherDetailedInfo.netTaxDue.currentYearvalue : this.otherDetailedInfo.totalDue.currentYearvalue;
      this.otherDetailedInfo.totalDue.currentYearvalue = (this.otherDetailedInfo.underPaymentPenalties.currentYearvalue) ? this.otherDetailedInfo.totalDue.currentYearvalue + this.otherDetailedInfo.underPaymentPenalties.currentYearvalue : this.otherDetailedInfo.totalDue.currentYearvalue;
  
      this.otherDetailedInfo.totalDue.difference = this.otherDetailedInfo.totalDue.currentYearvalue - this.otherDetailedInfo.totalDue.lastYearValue;
    }
  
    hideReveal(key){
      this.reveal[key] = false;
      if (key == 'addSuggestionToEstimate') {
        this.selectedStrategies = [];
        this.selectedSuggestions = [];
        this.isSuggestionExist = false;
      }
      if (key == 'showStrategies') {
        this.selectedViewStrategy = '';
      }
    }
  
    showFormulaInfo(key) {
      if (key == 'marginalTaxRate') {
        window.open('https://www.nerdwallet.com/article/taxes/federal-income-tax-brackets');
      } else {
        this.reveal.displayFormulaInfo = true;
        this.currentInfoKey = key;
      }
    }
  
    openStrategiesList() {
      this.reveal.showStrategies = true;
    }
  
    getStrategiesList() {
      const data = {fromIndex : -1};
      this.taxStrategyServices.getPaginatedTaxStrategies(this.org, this.user.id, data)
        .subscribe(response => {
          this.strategiesList = response.strategies;
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          error = JSON.parse(error);
          const message = error.message ? error.message : `Failed To Perform Operation`;
          try {
            this.toastService.pop(TOAST_TYPE.error, message);
          } catch (e) {
            this.toastService.pop(TOAST_TYPE.error, message);
          }
        });
  
    }
  
    getEstimateSuggestions() {
      const data = {fromIndex : -1};
      this.taxStrategyServices.getEstimateStrategiesSuggestions(this.org, this.user.id)
        .subscribe(response => {
          this.suggestionsData = response;
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          error = JSON.parse(error);
          const message = error.message ? error.message : `Failed To Perform Operation`;
          try {
            this.toastService.pop(TOAST_TYPE.error, message);
          } catch (e) {
            this.toastService.pop(TOAST_TYPE.error, message);
          }
        });
  
    }
  
    openStrategyInfo(strategy) {
      this.selectedViewStrategy = strategy;
    }
  
    viewStrategy() {
      this.reveal.showStrategies = false;
      if (this.selectedViewStrategy && !this.selectedViewStrategy.locked){
        this.switchBoard.onDisplayFloatingWindow.next({
          title: 'Strategy Info',
          url: ['tax-planning', 'taxStrategies', this.selectedViewStrategy.id],
        });
      }
    }
  
    addSuggestedStrategyToEstimate(type, key) {
      this.isSuggestionExist = (this.suggestionsData && this.suggestionsData.hasOwnProperty(key)) ? true : false;
      if (this.isMinimized) {
        this.isMinimized = false;
        this.reveal.addSuggestionToEstimate = true;
      } else {
        this.currentObject = type;
        this.currentKey = key;
        this.currentNotes = type[key].notes;
        this.suggestionsList = this.suggestionsData[key];
        _.each(this.suggestionsList, (strategy) => {
          strategy.selected = false;
        });
        this.reveal.addSuggestionToEstimate = true;
      }
    }
  
    onStrategyFilterSelect(strategy: any, check) {
      if (check) {
        this.openAddStrategyPopup(strategy, false);
      }
    }
  
    onAllStrategiesFilterSelect(clients: any, check) {
  /*
      this.resetSelectedCheckBoxes();
      if (check) {
        this.selectedClient = _.map(clients, 'clientId');
        this.filterObj.clientIds = this.selectedClient;
      } else {
        this.filterObj.clientIds = [];
        this.selectedClient = [];
      }
      this.nextIndex = 0;
      this.fetchNextSet(true);
  */
    }
  
    addSelectedStrategies(type?) {
      let strArray = [];
      if (this.currentNotes) {
        strArray.push(this.currentNotes);
      }
  
      _.each(this.suggestionsList, (suggestion) => {
        if (suggestion.selected) {
          this.selectedSuggestions.push(suggestion);
        }
      });
      if (type && type == 'suggestion') {
        if (this.selectedSuggestions.length > 0) {
          _.each(this.selectedSuggestions, (strategy) => {
            strArray.push(strategy.strategyName);
          });
        }
      }
      if (this.selectedStrategies.length > 0) {
        _.each(this.selectedStrategies, (strategy) => {
          strArray.push(strategy.name);
        });
      }
      strArray = _.uniq(strArray);
      this.currentObject[this.currentKey].notes = strArray.join(',');
      this.hideReveal('addSuggestionToEstimate');
    }
  
    viewStrategyInfo(strategy, type?) {
      if (strategy && !strategy.locked){
        this.switchBoard.onDisplayFloatingWindow.next({
          title: 'Strategy Info',
          url: ['tax-planning', 'taxStrategies', (type && type == 'other') ? strategy.id : strategy.strategyId],
        });
      }
    }
  
    openAddStrategyPopup(suggestion, isSuggestion?) {
      if (suggestion.selected || !isSuggestion) {
        this.minimizeReveal('addSuggestionToEstimate');
        this.currentSelectedSuggestion = suggestion;
        this.reveal.addStrategyFromEstimate = true;
      } else {
        this.reveal.addStrategyFromEstimate = false;
      }
    }
  
    minimizeReveal(key){
      this.isMinimized = true;
      this.reveal[key] = false;
    }
  
    triggerOnAddStrategy(data) {
      if (data && data.addCustomRate) {
        this.triggerRefreshStrategies.emit();
      } else {
        this.reveal.addStrategyFromEstimate = false;
        this.addSuggestedStrategyToEstimate(this.currentObject, this.currentKey);
        this.triggerRefreshStrategies.emit();
      }
    }

      /**
   * Returns the current Detailed Calculation state
   * for persistence by the parent component.
   */
    buildDetailReportPayload(): any {
      return {
        incomeInfo: this.incomeInfo || {},
        adjustmentsToIncomeInfo: this.adjustmentsToIncomeInfo || {},
        otherDetailedInfo: this.otherDetailedInfo || {}
      };
    }
  }
  